import { WorkProfileDto, WorkUser } from '@work-frontend-monorepo/work-rest-api';

export class ProfileStateSetProfile {
  static readonly type = '[UserState] Set profile';

  constructor(public profile: WorkProfileDto) {}
}

export class ProfileStateSetUser {
  static readonly type = '[UserState] Set user';

  constructor(public user: WorkUser) {}
}

export class ProfileStateSetAppDeviceId {
  static readonly type = '[UserState] Set app device ID';

  constructor(public appDeviceId: number) {}
}
